import React from 'react';
import { PricingCard } from './PricingCard';
import { ExampleWebsites } from './ExampleWebsites';

const PRICING_DATA = {
  basic: {
    title: 'BASIC PACKAGE',
    price: '$297',
    features: [
      { text: 'Lead capture system setup' },
      { text: 'Basic lead nurturing workflows' },
      { text: 'Monthly performance analytics' },
      { text: 'Email support' },
      { text: 'Advanced lead generation campaigns' },
      { text: 'Automated email marketing sequences' },
      { text: 'Custom landing pages' },
      { text: 'A system to get 5-star Google and Yelp Reviews' },
    ],
  },
  advanced: {
    title: 'ADVANCED PACKAGE',
    price: '$797',
    features: [
      { text: 'Everything in Basic Package, plus:', hideIcon: true },
      { text: 'Comprehensive tax preparation systems' },
      { text: 'Priority email support' },
      { text: 'Phone support' },
    ],
  },
  premium: {
    title: 'PREMIUM PACKAGE',
    price: '$1997',
    features: [
      { text: 'Everything in Advanced Package, plus:', hideIcon: true },
      { text: 'Radio show marketing setup & management' },
      { text: 'Weekly strategy calls' },
      { text: '24/7 VIP support' },
      { text: 'Quarterly business review' },
    ],
  },
};

interface PricingSectionProps {
  onGetStarted: () => void;
}

export const PricingSection: React.FC<PricingSectionProps> = ({ onGetStarted }) => {
  return (
    <section className="max-w-6xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold mb-4">Choose Your Perfect Package</h2>
        <p className="text-xl text-gray-300">
          Transform your financial services business with our comprehensive solutions
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <PricingCard
          variant="basic"
          title={PRICING_DATA.basic.title}
          price={PRICING_DATA.basic.price}
          features={PRICING_DATA.basic.features}
          onGetStarted={onGetStarted}
          showAdvisorGrowThumbnail={true}
          externalLink="https://advisorgrow.associates"
        />
        <PricingCard
          variant="advanced"
          title={PRICING_DATA.advanced.title}
          price={PRICING_DATA.advanced.price}
          features={PRICING_DATA.advanced.features}
          onGetStarted={onGetStarted}
          showTaxProThumbnail={true}
          externalLink="https://taxpro.associates"
        />
        <PricingCard
          variant="premium"
          title={PRICING_DATA.premium.title}
          price={PRICING_DATA.premium.price}
          features={PRICING_DATA.premium.features}
          onGetStarted={onGetStarted}
          showRadioThumbnail={true}
          externalLink="https://radioadvisors.associates"
        />
      </div>
      
      <p className="text-center mt-8 text-gray-300">
        *Each package includes a 180-day satisfaction guarantee.
      </p>

      <ExampleWebsites />
    </section>
  );
};